/**
 * Sets up initial form data based on defaults defined by the field configs,
 * overridden by any initial data provided.
 * @param options.fields If provided, the list of field configs is iterated
 * through to find default values for each field.
 * @param options.initialData If provided, this data overrides any default
 * values from the `fields` option and set the data for the given properties.
 */
export default <T = GenericFormData>(
  options: {
    fields?: FieldConfig[]
    initialData?: Partial<T>
  },
) => {
  const { fields, initialData } = options;
  const data: { [key: string]: unknown } = {};
  if (fields) {
    fields.forEach(field => {
      if (field.type === 'choice') {
        if (field.options?.length === 1) {
          data[field.id] = field.options[0].value;
        }
      }
      if (typeof field.default !== 'undefined') {
        data[field.id] = field.default;
      }
    });
  }

  return { ...data, ...(initialData || {}) } as T;
};
